/**
 * Soft-ask store — persistent флаг «спрашивали ли уже имя/ДР».
 *
 * JB doc 18 «Прогрессивный профиль» — главные принципы:
 *   - спрашиваем РАЗ, не повторно
 *   - можно мягко пропустить
 *   - формулировка: «только если хочешь — Сай узнает»
 *
 * Game store (где живёт profile.displayName) не persistится — это
 * узкий store специально для «уже спросили» флага.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ProfileAskStore {
  /** Спрашивали ли имя. После true — больше не показываем soft-ask. */
  readonly nameAsked: boolean;
  /** Спрашивали ли ДР. После true — больше не показываем DOB soft-ask. */
  readonly dobAsked: boolean;
  markNameAsked(): void;
  markDobAsked(): void;
  /** Test-only reset. */
  _reset(): void;
}

export const useProfileAskStore = create<ProfileAskStore>()(
  persist(
    (set) => ({
      nameAsked: false,
      dobAsked: false,
      markNameAsked() {
        set({ nameAsked: true });
      },
      markDobAsked() {
        set({ dobAsked: true });
      },
      _reset() {
        set({ nameAsked: false, dobAsked: false });
      },
    }),
    {
      name: 'sai-profile-ask-v1',
    },
  ),
);
